<div *ngIf="!showFareFamilyOptions" class="mr-xsmall-t" data-testid="cabin-class-options">
  <button
    class="grey-25-bg pr-small-r border-top border-right border-left fill flex flex--space-between flex--wrap flex--middle cabin-class-option"
    *ngFor="
      let fareFamily of cheapestOrSelectedFareFamilyOfEachCabinClass$ | async;
      let first = first;
      let last = last;
      let index = index;
      trackBy: trackByFn
    "
    [ngClass]="{
      'nordic-blue-900-border': fareFamily.selected,
      'rounded-top-large': first && !last,
      'rounded-bottom-large': last && !first,
      'rounded-large': last && first,
      selected: fareFamily.selected,
      'border-bottom': last || fareFamily.selected,
    }"
    (click)="showFareFamiliesAndScrollToCabinClass($event, fareFamily)"
    [attr.data-testid]="'cabin-class-option-' + fareFamily.cabinClass"
    [disabled]="fareFamily.disabled"
  >
    <span class="flex fill">
      <span
        class="flex--nogrow flex--middle flex highlight mr-small-r"
        [ngClass]="{
          'rounded-top-left-large': first && !last,
          'rounded-bottom-left-large': last && !first,
          'rounded-left-large': last && first,
        }"
      >
        <span class="ps-xsmall">
          <fcom-icon
            class="icon-medium circle"
            [ngClass]="{
              'white-border nordic-blue-900-bg white-text': fareFamily.selected,
              'nordic-blue-900-border white-bg': !fareFamily.selected,
            }"
            [name]="fareFamily.selected ? SvgLibraryIcon.CHECKMARK : SvgLibraryIcon.RADIOBUTTON_UNSELECTED"
          ></fcom-icon>
        </span>
      </span>
      <span class="flex-1 flex flex--wrap ps-xsmall-y spacer-tablet-down">
        <span class="flex-1 flex flex--middle pr-small-r font-body-1">
          <ng-container *ngIf="fareFamily.selected">
            {{ fareFamily.brandName }}
          </ng-container>
          <ng-container *ngIf="!fareFamily.selected">
            {{
              ('travelClass.' + fareFamily.cabinClass?.toLowerCase() | finLocalization) ||
                ('travelClass.mixed' | finLocalization)
            }}
          </ng-container>
        </span>

        <span class="flex flex--middle price-container">
          <span
            *ngIf="!fareFamily.selected && !fareFamily.points"
            class="nordic-blue-900-text font-body-1 bold-type ps-xsmall-r"
            data-testid="cabin-class-from-price-text"
            >{{ 'pricesStartingFrom' | finLocalization }}</span
          >

          <span class="font-heading-5 bold-type heather-700-text" *ngIf="fareFamily.points"
            >{{ 'award.points' | finLocalization: { pointsAmount: +fareFamily.points || 0 | finPoints } }} +&nbsp;</span
          >

          <span class="font-heading-5 bold-type heather-700-text">{{
            { amount: fareFamily.price, currencyCode: currencyCode$ | async } | finPrice
          }}</span>
        </span>
      </span>
    </span>
  </button>
</div>

<div class="fare-family-option-list-container relative mr-xsmall-t" *ngIf="showFareFamilyOptions">
  <div
    #activeCabinClassHeaderContainer
    class="fare-family-option-list-header-container grey-25-bg border-top border-right border-left fill ps-xsmall-y pr-xsmall-l pr-small-r flex flex--space-between flex--wrap flex--middle rounded-top-large"
    tabindex="0"
    data-testid="active-cabin-class-header"
  >
    <span class="flex flex--middle">
      <span data-testid="active-cabin-class-header-title">{{
        'ticketSelection.header.selectTicketTypeBelow' | finLocalization
      }}</span>
    </span>

    <button
      (click)="hideFareFamilies($event)"
      title="{{ 'actions.close' | finLocalization }}"
      [attr.aria-controls]="'option-list-' + (bound$ | async).id"
      [attr.aria-expanded]="true"
      data-testid="cabin-class-header-close-button"
    >
      <fcom-icon [name]="SvgLibraryIcon.CLOSE_DELETE"></fcom-icon>
    </button>
  </div>

  <fin-scroll-handle-container
    [id]="'option-list-' + (bound$ | async).id"
    class="grey-25-bg block"
    *ngIf="extendedFareFamilies$ | async as extendedFareFamilies"
    [elements]="fareFamilyOptions"
    (scrollElements)="scrollBenefits.emit($event)"
    #scrollContainer
  >
    <div class="flex ps-medium-y pr-xsmall-x">
      <fin-fare-family-option
        #fareFamilyOption
        *ngFor="let fareFamily of extendedFareFamilies; let lastFareFamily = last; index as i; trackBy: trackByFn"
        [context]="GaContext.FLIGHT_SELECTION"
        [accordionId]="accordionId"
        [currencyCode$]="currencyCode$"
        [fareFamily]="fareFamily"
        [routeType]="routeType$ | async"
        [isShortHaul]="isShortHaul$ | async"
        (selectFareFamily)="handleSelectFareFamily($event)"
        (showDimensionsAndDetails)="handleShowBenefits()"
      ></fin-fare-family-option>
    </div>
  </fin-scroll-handle-container>
  <fcom-notification
    class="ps-xsmall-y"
    [theme]="NotificationTheme.INFO"
    [iconName]="SvgLibraryIcon.INFO_BLOCK"
    [horizontal]="true"
    data-testid="compare-tickets-notification"
  >
    <button
      class="link medium-type underline"
      data-testid="compare-tickets-notification-btn"
      (click)="handleShowBenefits()"
    >
      {{ 'ticketSelection.baggageAndTicketTypeDetails' | finLocalization }}
    </button>
  </fcom-notification>
</div>
